const id_trans_returncuslist = {
    "": "supervisi retur pelanggan",
    view: "detail retur pelanggan",
    add: "tambah retur pelanggan",
    payment: "pembayaran retur pelanggan",
    label: {
        create_do: "buat delivery order"
    },
}

export default id_trans_returncuslist;